export default __webpack_public_path__ + "static/media/solar-panel.0fcdb99a.svg";